<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Adhoc Vehicle Freight</strong>
                    </div>
                    <div>
                    <b-row class="mb-5">
                        <h6>Requested Adhoc Plan</h6>
                        <b-table show-empty responsive :fields="fields" :items="vendorPendingRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status }}</strong>
                            </div>
                        </template>
                        <template slot="basefreight" slot-scope="row">
                            <div>
                                <span v-if="row.item && row.item.basefreight" class="cutom-view-all-btn">{{ row.item.basefreight }}</span>
                                <span v-else class="cutom-view-all-btn">NA</span>
                            </div>
                        </template>
                        <template slot="vendorlist" slot-scope="row">
                            <div>
                                <button><i class="fa fa-clipboard" aria-hidden="true"></i></button>
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                        <!-- <template #table-caption><b>Incidents Listed</b></template> -->
                    </b-table>
                    </b-row>
                </div>   
                <b-row class="mb-5">
                       <b-col md="5">
                        <b-form-group label="Search Vendor :" :label-cols="3" class="mb-4">
                          <v-select
                            v-model="selected_vendor"
                            @input="searchVendoraName(requestId, selected_vendor && selected_vendor.vendorid)"
                            :options="vendorNameList"
                            label="transporter_company_name"
                            placeholder="-- Search Vendor --"
                            :custom-filter="filterVendor"
                          >
                            <!-- <template #option="option">
                              {{ option.transporter_company_name || 'No Name' }} (ID: {{ option.vendorid }})
                            </template> -->
                          </v-select>


                    </b-form-group>
                       </b-col>
                       <b-col md="7" class="text-right">
                        <b-button variant="primary" @click="addNewFreight()"> Add Freight + </b-button>&nbsp;
                        <b-button variant="primary" @click="addVendor()"> Add vendor + </b-button>&nbsp;
                        <b-button variant="primary" @click="UploadFreightPopUp()"> Upload CSV File + </b-button>&nbsp;
                       
                        <!-- <b-button variant="primary">
      <label for="csvFile" class="mb-0">Upload Freight</label>
      <b-form-file
        id="csvFile"
        class="d-none"
        v-model="file"
        @change="uploadcsvFile($event)"
        accept=".csv"
      ></b-form-file>
    </b-button> -->
                       </b-col>
                </b-row>
              <div v-if="vendorInfoList && vendorInfoList.length > 0">
                <b-row>
                    <b-col>
                        <div class="text-right" md='3'>
                          <button class="custom-Freight-lowest-price">Lowest Freight :- <span v-if="vendorInfoList && vendorInfoList[0] && vendorInfoList[0].basefreight">{{ vendorInfoList[0].basefreight  }}</span></button>
                        </div>

                        <b-table show-empty responsive
                        :fields="fieldsFreight"
                        :items="vendorInfoList"
                        :busy="isBusy"
                        :sort-by.sync="sortByFreight"
                        :sort-desc.sync="sortDescFreight"
                        :sort-direction="sortDirectionFreight"
                        caption-top
                        class="custom-table-scrol"
                        v-bind:responsive="false"
                      >
    
                          <template slot="transporter_company_name" slot-scope="row">
                            <span v-if="!row.item.showDeleteIcon">
                                <span> {{ row.item.transporter_company_name }}</span>
                            </span>
                            <span v-if="row.item.showDeleteIcon === 1">
                              <v-select
                        v-model="row.item.vendor_id"
                        @input="searchVendoraNameTable(requestId, row.item.vendor_id && row.item.vendor_id.vendorid)"
                        :options="vendorNameListTable"
                        label="transporter_company_name"
                        placeholder="-- Search Vendor --"
                        :custom-filter="filterVendor"
                        class="custom-background-clear"
                      >
                        <!-- <template #option="option">
                          {{ option.transporter_company_name || 'No Name' }} (ID: {{ option.vendorid }})
                        </template> -->
                      </v-select>
                            </span>
                          </template> 
                          
                          <!-- action start here -->
                            <template slot="totalloads" slot-scope="row">
                              
                              <span v-if="row.item.bidid"><b-button variant="secondary" class="custom-table-icon" @click="toggleStar(row.index, row.item)" size="sm" :disabled="starDisable = false && selectedStarIndex !== row.index" title="Vendor Selection">
                                <i :class="{'fa fa-star': true, 'text-warning': selectedStarIndex === row.index}" aria-hidden="true"></i>
                              </b-button>&nbsp;</span>

                              <span v-if="row.item.addedbyadmin === 'Yes'"><b-button variant="secondary" class="custom-table-icon" @click.prevent="editField(row.index)" size=sm title="Edit"><i class="fa fa-edit" aria-hidden="true"></i></b-button></span>&nbsp;
                              <span v-if="currentEditIndex === null">
                              <span v-if="(row && row.item && row.item.freight && row.item.freightp && row.item.showDeleteIcon === 1) || row && row.item && row.item.freight && row.item.freightp && row.item.addedbyadmin === 'Yes'"><b-button variant="secondary"  class="custom-table-icon" @click="addFreightInfirmation(row.index, row.item)" size=sm title="Freight Select"><i class="fa fa-check" aria-hidden="true"></i></b-button>&nbsp;</span>
                            </span>
                              <span v-if="currentEditIndex != null">
                              <span v-if="(row && row.item && row.item.freight && row.item.freightp && row.item.showDeleteIcon === 1) || row && row.item && row.item.freight && row.item.freightp && row.item.addedbyadmin === 'Yes'"><b-button variant="secondary"  class="custom-table-icon" @click="editFreightInfirmation(row.index, row.item)" size=sm title="Edit Freight"><i class="fa fa-check" aria-hidden="true"></i></b-button>&nbsp;</span>
                              </span>
                              <span v-if="row.item.showDeleteIcon === 1 || row.item.addedbyadmin === 'Yes'">
                                <b-button variant="secondary" class="custom-table-icon" @click="removeFreightDetails(row.index, row.item)" size=sm title="Delete"><i class="fa fa-trash" aria-hidden="true"></i>
                                </b-button>&nbsp;
                              </span>
                          </template>

                          <!-- freight column here -->
                          <template slot="freight" slot-scope="row">

                              <span v-if="!row.item.showDeleteIcon">
                                <b-input type="number" v-model="row.item.freight" @input="changeFreightValue(row.index, row.item.freight)" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index, row) || row.item.suggested_vendor === 'Yes'}" :disabled="!isEditable(row.index)" @keypress="checkNegativeValue($event)"/>
                              </span>
                              <span v-if="row.item.showDeleteIcon === 1">
                                <b-input type="number" v-model="row.item.freight" @input="changeFreightValue(row.index, row.item.freight)" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index, row)}" @keypress="checkNegativeValue($event)"/>
                              </span>
                              
                          </template>   

                          <!-- freightp column here -->
                          <template slot="freightp" slot-scope="row">
                            <span v-if="!row.item.showDeleteIcon">
                              <b-input v-model="row.item.freightp" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index, row) || row.item.suggested_vendor === 'Yes'}" disabled />
                            </span>
                            <span v-if="row.item.showDeleteIcon === 1">
                              <b-input v-model="row.item.freightp" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index, row)}" disabled/>
                            </span>
                            </template>

                            <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                        </b-table>

                        <div class="mb-5">
  <b-row class="mt-3" v-if="selectedStarIndex !== null">
    <b-col md="4">
      <div class="mb-1"><strong>Suggested Reason</strong>&nbsp;<span style="color: red;">*</span> :-</div>
      <b-form-input
        id="textarea-default"
        placeholder="Enter Suggested Reason"
        v-model.trim="suggested_reason"
        :disabled="selectedStarIndex === null"
      ></b-form-input>
    </b-col>
    <b-col md="4">
      <div class="mb-1"><strong>Comment</strong> :-</div>
      <b-form-input
        id="textarea-default"
        placeholder="Enter Comment"
        v-model.trim="comment"
        :disabled="selectedStarIndex === null"
      ></b-form-input>
    </b-col>
    <b-col md="4" class="text-center">
      <div class="mb-4"></div>
      <b-button
        variant="primary"
        class="custom-Freight-lowest-price"
        @click="submitSuggestion()"
        :disabled="selectedStarIndex === null"
      >
        Submit
      </b-button>&nbsp;
    </b-col>
  </b-row>
</div>

                    </b-col>
                </b-row>
                    
                
                <div class="mb-3">

                <div class="custom-table-outer" v-if="getAllSuggestionList && getAllSuggestionList.length > 0">
                  <strong>Suggestions/Comments Log:</strong>
                  <b-table show-empty 
                      responsive
                      :fields="suggestionFields"
                      :items="getAllSuggestionList"
                      :busy="isBusy"
                      :sort-by.sync="sortBysuggestion"
                      :sort-desc.sync="sortDescsuggestion"
                      :sort-direction="sortDirectionsuggestion"
                      caption-top
                    >
                    <template slot="comment" slot-scope="row">
                      <span v-if="row.item.comment !== 'undefined' && row.item.comment !== undefined && row.item.comment !== 'null' && row.item.comment !== null && row.item.comment !== ''">
                        {{ row.item.comment }}
                      </span>
                        </template>   
                        <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                        </b-table>

                      </div>          
                </div>
              </div> 
              </b-card>
              
            </b-col>
            
        </b-row>


        <!-- pending vehicle master start here-->
        <b-modal title="Add New Vendor" size="xl" v-model="updateInfo" @ok="updateInfo = false" hide-footer class="text-center" @hidden="resetForm">
          <div class="mb-5">
            <b-row class="mb-4">
              <div class="col-3"><label><strong>Type of Vendor:</strong>&nbsp;<span style="color: red;">*</span></label></div>
              <div class="col-6">
                <b-form-group>
                  <b-form-radio-group 
                    v-model="addVendorDetails.vendortype" 
                    @change="validateVendorType"
                    :options="[
                        { text: 'Aggregator', value: 'aggregator' }, 
                        { text: 'Normal', value: 'normal' }
                    ]"
                    name="vendortype"
                  >
                </b-form-radio-group>
                </b-form-group>

              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Company Name:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Company Full Name"
                  v-model.trim="addVendorDetails.vendorCompanyName"
                  @change="validateCompanyName"
                ></b-form-input>
                <div v-if="errors.vendorCompanyName" class="text-danger">{{ errors.vendorCompanyName }}</div>
              </div>
            </b-row>
            
            <b-row class="mb-4">
              <div class="col-3">
                <strong>Transporter Name:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Transporter Name"
                  v-model.trim="addVendorDetails.transporter_name"
                  v-validate="'required'"
                  name= 'transporter_name'
                ></b-form-input>
                <div v-if="errors.transporter_name" class="text-danger">{{ errors.transporter_name }}</div>
              </div>
            </b-row>
 

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Mobile No:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Mob No."
                  v-model.trim="addVendorDetails.vendorMobileNo"
                  maxlength="12"
                  @change="validateMobileNo"
                ></b-form-input>
                <div v-if="errors.vendorMobileNo" class="text-danger">{{ errors.vendorMobileNo }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Email ID:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Email ID"
                  v-model.trim="addVendorDetails.vendorEmailId"
                  @change="validateEmail"
                ></b-form-input>
                <div v-if="errors.vendorEmailId" class="text-danger">{{ errors.vendorEmailId }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Add Freight:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Freight"
                  v-model.trim="addVendorDetails.addFreight"
                  @change="validateFreight"
                ></b-form-input>
                <div v-if="errors.addFreight" class="text-danger">{{ errors.addFreight }}</div>
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3">
                <strong>GST No:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter GST No."
                  v-model.trim="addVendorDetails.gstno"
                  @change="addGSTNumber"
                ></b-form-input>
                <div v-if="errors.gstno" class="text-danger">{{ errors.gstno }}</div>
              </div>
            </b-row>
            <!-- <b-row class="mb-4">
              <div class="col-3"> <label for="promotername"><Strong>Promoter Name <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-form-group>
                  <b-input-group>
                      <b-form-input class="input" type="text" id="promotername" name="promotername" v-model="addVendorDetails.promotername" v-validate="'required|max:50'" placeholder="Enter Promoter Name"></b-form-input>
                  </b-input-group>
                  <div v-if="errors.promotername" class="text-danger">{{ errors.promotername }}</div>
                  </b-form-group>
              </div>
            </b-row> -->
            <!-- <b-row class="mb-4">
              <div class="col-3"> <label><Strong>GSTIN Number <span  v-if="addVendorDetails.vendortype && addVendorDetails.vendortype.toLowerCase() == 'aggregator'" style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group  v-if="addVendorDetails.vendortype && addVendorDetails.vendortype.toLowerCase() == 'aggregator'">
                    <b-form-input class="input" type="text" id="gstin number" name="gstin number"   v-validate="'required' " v-model="addVendorDetails.gstinnumber" placeholder="Enter GSTIN Number" @change="validateGstinNo"></b-form-input>
                </b-input-group>
                <b-input-group v-else>
                    <b-form-input class="input" type="text" id="gstin number" name="gstin number"  v-model="addVendorDetails.gstinnumber" placeholder="Enter GSTIN Number"></b-form-input>
                </b-input-group>
                <div v-if="errors.gstinnumber" class="text-danger">{{ errors.gstinnumber }}</div>
              </div>
            </b-row> -->
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>PAN <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                  <b-form-input class="input" type="text" id="pan number" name="pan number" v-model="addVendorDetails.pan" v-validate="'required|max:50'" placeholder="Enter PAN Number"></b-form-input>
              </b-input-group>
              </div>
              <div v-if="errors.pan" class="text-danger">{{ errors.pan }}</div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Aadhaar <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text" id="adhaar number" name="adhaar number" v-model="addVendorDetails.aadhar" v-validate="'required|max:50'" placeholder="Enter Aadhaar Number"></b-form-input>
                </b-input-group>
              </div>
              <div v-if="errors.aadhar" class="text-danger">{{ errors.aadhar }}</div>
            </b-row>
            
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Bank Cancelled Cheque <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-form-file
                    type="file"
                    v-model="addVendorDetails.bankcancelledcheque"
                    placeholder="Bank Cancelled Cheque" 
                    @change="selectBankChequeFile($event)"
                    class="custom-border"
                    v-validate="'required'"
                    id="bank cancelled cheque" 
                    name="bank cancelled cheque"                                    >
                    <template v-slot:file-name >
                        {{ bankFileName }}
                    </template>
                </b-form-file>
              </div>
            </b-row> 

            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>GSTIN Certificate</Strong></label></div>
              <div class="col-6">
                <b-form-file
                    type="file"
                    v-model="addVendorDetails.gstincertificate"
                    placeholder="GSTIN Certificate" 
                    @change="selectGstinCertficateFile($event)"
                    class="custom-border"
                    id="gstin certficate" name="gstin certficate" 
                    >
                    <template v-slot:file-name>
                        {{ gstinCertficateFilename }}
                    </template>
                </b-form-file>
              </div>
            </b-row>
            
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Pincode</Strong></label></div>
              <div class="col-6">
                <b-form-group>
                  <v-select v-model="addVendorDetails.pincode" :options="pincodes" placeholder="-- Select Pincode --" @change="pincodeChange(addVendorDetails.pincode)"></v-select>
                  <b-input-group>
                      <span
                          style="width:240px"
                          class="help text-danger"></span>
                      </b-input-group>
                  </b-form-group>
                  <!-- <div v-if="errors.pincode" class="text-danger">{{ errors.pincode }}</div> -->
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Address <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input"
                    type="text" id="address" name="address" v-model="addVendorDetails.address" placeholder="Enter Address"></b-form-input>
                </b-input-group>
              </div>
              <div v-if="errors.address" class="text-danger">{{ errors.address }}</div>
            </b-row>
            <b-row class="mb-4" v-if="addVendorDetails.pincode">
              <div class="col-3"> <label><Strong>City</Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text" id="city" name="city" v-model="addVendorDetails.city" placeholder=""></b-form-input>
                </b-input-group>
              </div>
            </b-row>
            <b-row class="mb-4" v-if="addVendorDetails.pincode">
              <div class="col-3"> <label><Strong>State</Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text" id="state" name="state" v-model="addVendorDetails.state" placeholder=""></b-form-input>
                </b-input-group>
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Bank name <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" v-validate="'required'"
                    type="text" id="bankname" name="bankname" v-model="addVendorDetails.bankname" placeholder="Enter Bank name"></b-form-input>
                </b-input-group>
                <div v-if="errors.bankname" class="text-danger">{{ errors.bankname }}</div>
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Bank Account Name <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text"  v-validate="'required'" id="bankaccountname" name="bankaccountname" v-model="addVendorDetails.bankaccountname" placeholder="Enter Bank Account Name" ></b-form-input>
                </b-input-group>
              </div>
              <div v-if="errors.bankaccountname" class="text-danger">{{ errors.bankbanknameaccountname }}</div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Branch Name <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text"   v-validate="'required'" id="branchname" name="branchname" v-model="addVendorDetails.branchname" placeholder="Enter Branch Name"></b-form-input>
                </b-input-group>
                <div v-if="errors.branchname" class="text-danger">{{ errors.branchname }}</div>
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>Account number <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group>
                    <b-form-input class="input" type="text" id="accountnumber" name="accountnumber" v-model="addVendorDetails.accountnumber" placeholder="Enter Account number"></b-form-input>
                </b-input-group>
              </div>
            </b-row>
            <b-row class="mb-4">
              <div class="col-3"> <label><Strong>IFSC Code <span style="color: red;">*</span></Strong></label></div>
              <div class="col-6">
                <b-input-group class="mb-3">
                    <b-form-input class="input"  type="text" id="ifsccode" name="ifsccode" v-model="addVendorDetails.ifsccode" placeholder="Enter IFSC Code"></b-form-input>
                </b-input-group>
              </div>
            </b-row>
          </div>
          <b-row>
            <b-col md="12" class="mb-5 text-center">
                <b-button variant="primary" @click="submitvenodr()"> Submit </b-button>&nbsp;
                <b-button variant="danger" @click="closeVendorModal()"> Close </b-button>&nbsp;
            </b-col>
          </b-row>
        </b-modal>  
        <!-- pending vehicle master end here -->


        <!-- plan modal start here -->
        <b-modal :title="'View Plan Screen'" v-model="plandetailsmodal" size="xl" hide-footer modal-class="text-center">
            
          <template slot="default" slot-scope="{ hide }">

              <div id="listloader" v-if="loadermodel">
                  <div class="listloader"></div>
              </div>
              <template>
                <b-row>
                    <b-col sm="4">
                        <b-input-group>
                            <b-input-group-prepend>
                                <span class="d-flex text-center m-auto mr-2"><strong>Search Load :- </strong></span> &nbsp;
                            </b-input-group-prepend>&nbsp;
                            <b-form-input v-model="filter" placeholder="Enter Parent AWB / Load ID" @input="searchdata"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="clearFilterPlan">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col  sm="3">
                        <strong>vehicle No :- </strong> <b v-if="planScrrenDetails && planScrrenDetails[0] && planScrrenDetails[0].vehicle_no">{{ planScrrenDetails[0].vehicle_no }}</b>
                    </b-col>
                    <b-col  sm="3">
                        <strong>Origin :- </strong> <b v-if="planScrrenDetails && planScrrenDetails[0] && planScrrenDetails[0].origin">{{ planScrrenDetails[0].origin }}   </b>
                    </b-col>
                    <b-col  sm="2">
                        <strong>Records :- </strong> <b class="text-danger">{{planScrrenDetails_count}}</b>
                    </b-col>
                </b-row>
            </template>
              <!-- <b-col sm="12" class="text-right">
                  <strong>Total Records : </strong><b style="color: red;">{{planScrrenDetails_count}}</b>
              </b-col> -->
              <b-table show-empty responsive :fields="fieldsPlanScrren" :items="planScrrenDetails" :filter="filter" :busy="planisBusy" :sort-by.sync="sortByPlan" :sort-desc.sync="sortDescPlan" :sort-direction="sortDirectionPlan">
                  <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                  </div>
              </b-table>  
              <div class="text-right" v-if="planScrrenDetails_count && showApproveButton=='showApproveButton'">
                  <b-button class="shrek-color mt-1" @click="approveALLRequest('table',planDetails)" size="sm">
                      <i class="fa fa-check" aria-hidden="true"></i>
                  </b-button> &nbsp; 
                  <b-button class="mt-1" variant="danger" @click="rejectedRequest(planDetails.requestid)" size="sm">
                      <i class="fa fa-times" aria-hidden="true"></i>
                  </b-button>
              </div> 
              <!-- pagination -->
              <paginate v-model="planviewpageNum"
                      :page-count="planviewnoofpages"
                      :page-range="10"
                      :margin-pages="2"
                      :click-handler="planViewclickCallback"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination'"
                      :page-class="'page-item'">
                  </paginate>             
          </template>
                 
         
          <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                  Cancel
              </b-button>
          </template>
      </b-modal>
      <!-- plan modal end here -->  
                <!-- pending vehicle master end here -->


                  <!-- pending vehicle master start here-->
                  <b-modal title="Upload Freight CSV" size="lg" v-model="uploadCSVModal" @ok="uploadCSVModal = false" hide-footer>
  <b-row class="mb-3 d-flex justify-content-center">
    <a :href="loadurl" target="_blank">
      <b-button variant="primary" @click="downloadVendorCSV()">Download Vendor Details</b-button>
    </a>
  </b-row>
  <b-row class="mb-3 d-flex justify-content-center">
    <b-col md="7">
      <div class="mb-1">Upload Freight</div>
      <b-form-file
        id="csvFile"
        v-model="file"
        accept=".csv"
        placeholder="Choose a CSV file..."
      ></b-form-file>
      
      <a href="https://stageplm.brainbees.com/api_ftl/downloadcsv?key=uploadfiletos3-2024-11-10-bidtest-sample-csv.csv" download="bidtest.csv">Download Sample CSV</a>
      <!-- <a href="/img/bidtest.csv" download="bidtest.csv">Download Sample CSV</a> -->
    </b-col>
    <b-col md="2" class="margin-auto">
      <div class="mb-4"></div>
      <b-button
        variant="primary"
        @click="uploadcsvFile"
        :disabled="!file"
        class="mt-2 mt-md-0"
      >
        Upload
      </b-button>
    </b-col>
  </b-row>
</b-modal>

        <!-- plan modal start here -->
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Swal from 'sweetalert2';
const axios = require('axios')

export default {
  data() {
    return {
      requestId: null,  // Initialize to store the route param
      showpopup:'',
      fields : [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'totalloads', label : 'Total Loads', sortable: true},
                { key : 'totalmps', label : 'Total MPS', sortable: true},
                { key : 'totalvolwt', label : 'Total Vol. Wt(Tonn)', sortable: true},
                { key : 'lastmodifiedby', label : 'Last modified By & On', sortable: true},
                { key : 'createddate', label : 'Request Date', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'basefreight', label : 'Base Freight', sortable: true},
                { key : 'invoicevalue', label : 'Invoice Value', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'delivery_locations', label : 'Destination', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true}
        ],
        fieldsFreight: [ 
        { key: "basefreight", label: "Base Freight" , sortable: true},
        { key: "transporter_company_name", label: "Vendor Name" , sortable: true},
        { key: "freight", label: "Freight" , sortable: true},
        { key: "freightp", label: "Freight %" , sortable: true},
        { key: "totalloads", label: "Action" , sortable: true},
        ],
        vendorPendingRequest: [],
        vendorInfoList:[],
        selected_vendor: '',
        selected_vendor_table: '',
        vendorNameList: [],
        vendorname: null,
        filter: "",
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      sortByFreight: "",
      sortDescFreight: false,
      sortDirectionFreight: "asc",
      sortBysuggestion: "",
      sortDescsuggestion: false,
      sortDirectionsuggestion: "asc",
      sortByPlan: "",
      sortDescPlan: false,
      sortDirectionPlan: "asc",
      allTransporterVenList: [],
      updateInfo:false,
      addVendorDetails: {
        vendorCompanyName: '',
        vendorMobileNo: '',
        vendorEmailId: '',
        addFreight: ''
      },
      errors: {
        vendorCompanyName: null,
        vendorMobileNo: null,
        vendorEmailId: null,
        addFreight: null,
      },
      starredItems: [], // Array to keep track of which rows have a starred icon
      starredRows: [], // Array to store the indexes of starred rows
      suggestionFields: [ 
        { key: "createddate", label: "Log Date & Time" , sortable: true},
        { key: "createdby", label: "Log Updated By" , sortable: true},
        { key: "logtype", label: "Log Type" , sortable: true},
        { key: "transporter_company_name", label: "Vendor Suggested" , sortable: true},
        { key: "reason", label: "Reason" , sortable: true},
        { key: "comment", label: "Comment" , sortable: true},
        ],
      getAllSuggestionList: [],
      showDeleteIcon: 0,
      selectcsvFile: "",
      file: "",
      selectFiletype: "",
      acceptedloads: [],
      enableSuggestionAndComment: false,
      disableSuggestionReasonFreight: false,
      suggested_reason: '',
      comment: '',

      // plan model
      plandetailsmodal: false,
            fieldsPlanScrren : [ 
                { key : 'origin', label : 'Planning Origin', sortable: true, sortDirection: "desc"},
                { key : 'planningdate', label : 'Planning Date', sortable: true, sortDirection: "desc"},
                { key : 'load_id', label : 'Load ID' , sortable: true, sortDirection: "desc"},
                { key : 'wh_hub', label : 'WH / HUB', sortable: true, sortDirection: "desc"},
                { key : 'mpscount', label : 'No Of Boxes', sortable: true, sortDirection: "desc"},
                { key : 'parentawb', label : 'Shipping Reference No', sortable: true, sortDirection: "desc"},
                { key : 'userid', label : 'User ID', sortable: true, sortDirection: "desc"},
                { key : 'destinationcompanyname', label : 'Company Name', sortable: true, sortDirection: "desc"},
                { key : 'destinationcity', label : 'Destination City', sortable: true, sortDirection: "desc"},
                { key : 'warehousename', label : 'Warehouse Name / Hub Zone', sortable: true, sortDirection: "desc"},
                { key : 'loadpotype', label : 'Load Po Type', sortable: true, sortDirection: "desc"},
                { key : 'valweight', label : 'shipment Volumetric weight', sortable: true, sortDirection: "desc"},
                { key : 'destinationpincode', label : 'Shipping code', sortable: true, sortDirection: "desc"},
                { key : 'unload_sequence', label : 'unloading sequence', sortable: true, sortDirection: "desc"},
            ],
            planScrrenDetails: [],
            planScrrenDetails_count :0,
            planisBusy:false,
            planDetails:{},
            showApproveButton:'',

            planviewpageNum:1,
            planviewnoofpages:'',
            loadermodel:false,
            uploadCSVModal: false,
            loadurl :'',
            starDisable: false,
            selectedStarIndex: null,  // Track the selected star
            vendorNameListTable: [],
            currentVendorList: [],
            currentBidID: 0,
            currentEditIndex: null,  // Track the current row being edited
            vendorNameListAll: [],
      selectedBankCheque: '',
      pincodes: [],
      pincodeCityData: [],
      bankFileName: '',
      bankcancelledcheque: '',
      bankFileType: '',
      selectedGstinCertficate: '',
      gstincertificate: '',
      gstinCertficateType: '',
      gstinCertficateFilename: ''
    };
  },
  created () {
   
   
  },
  mounted () {
     // Access the dynamic 'id' from the route params
     this.requestId = this.$route.params.id;
      console.log("this.$route.",this.$route.query.flag)
      this.showpopup=this.$route.query.flag;
      if (this.requestId) {
        this.fetchAllFreightList(this.requestId),
        this.allVendorList();
        this.allTransporterVendorList();
        this.getPincodeList();
      }
    if (this.showpopup==='showpopup') {
      this.rejectFreightAndVendorRequest()
    }
  //  this.tableVendorNameList();
    this.getAllSuggestion();
  },
  watch: {
    searchVendor(newSearchValue) {
      this.filterVendorList(newSearchValue);
    }
  },

  methods: {
    filterVendorList(search) {
    if (!search) {
      // If no search input, show all options
      this.filteredVendorList = this.vendorNameList;
      return;
    }

    const searchText = search.toLowerCase();

    this.filteredVendorList = this.vendorNameList.filter(option => {
      const nameMatch = option.transporter_company_name
        ? option.transporter_company_name.toLowerCase().includes(searchText)
        : false;

      const idMatch = String(option.vendorid).includes(searchText);

      return nameMatch || idMatch;
    });
  },

    
    rejectFreightAndVendorRequest() {
        if (this.$route && this.$route.params && this.$route.params.id === this.requestId) {
            this.outerRejectedRequest()
        }
    },

    outerRejectedRequest(value) {
            // this.selectrequestid = [];
            // this.selectapproverequest = [];
            // this.isCheckAll = false;

            Swal.fire({
                title: "<h3>Request Reconsider</h3><hr>",
                html: `
                Please enter the reason for Reconsider.
                <br/><br/>
                <div style="display: flex; justify-content: space-around; align-items: center;">
                    <label for="reason" style="margin-right: 10px;"><strong>Reason:</strong></label>
                    <textarea id="reason" rows="4" style="width: 70%;"></textarea>
                </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Submit",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
                preConfirm: () => {
                    const reason = document.getElementById('reason').value;
                    if (!reason) {
                        Swal.showValidationMessage('Please enter a reason');
                    }
                    return { reason: reason };
                }
            }).then((result) => {
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader = true;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    let result1 = ''
                    result1 = this.vendorInfoList.find(item => item.suggested_vendor === 'Yes')
                    // console.log(result1, 'result1result1')
                    const obj = {
                        requestid: this.requestId,
                        bidid: result1 && result1.bidid ? result1.bidid : null,
                        createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                        // sysusermasterid: userInfo.sysusermasterid,
                        sysusermasterid: userInfo.sysusermasterid,
                        reason: result.value.reason,  // Use result.value.reason here
                    };
                    // console.log(obj, 'objectttttt reconsider');
                    // return false;
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markVendorReconsiderForRequest`, obj).then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Request Successfully Rejected!",
                                type: "success",
                                timer: 3000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            // this.getPendingList(1);
                            this.getAllSuggestion();
                        } else {
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 3000,
                            });
                        }
                    }).catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            });
        },

    rejectedRequest(value) {
            // this.selectrequestid = [];
            // this.selectapproverequest = [];
            // this.isCheckAll = false;

            Swal.fire({
                title: "<h3>Request Reconsider</h3><hr>",
                html: `
                Please enter the reason for Reconsider.
                <br/><br/>
                <div style="display: flex; justify-content: space-around; align-items: center;">
                    <label for="reason" style="margin-right: 10px;"><strong>Reason:</strong></label>
                    <textarea id="reason" rows="4" style="width: 70%;"></textarea>
                </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Submit",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
                preConfirm: () => {
                    const reason = document.getElementById('reason').value;
                    if (!reason) {
                        Swal.showValidationMessage('Please enter a reason');
                    }
                    return { reason: reason };
                }
            }).then((result) => {
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader = true;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        requestid: this.requestId,
                        bidid: this.currentBidID ? this.currentBidID : null,
                        createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                        // sysusermasterid: userInfo.sysusermasterid,
                        sysusermasterid: userInfo.sysusermasterid,
                        reason: result.value.reason,  // Use result.value.reason here
                    };
                    // console.log(obj, 'objectttttt');
                    // return false;
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markVendorReconsiderForRequest`, obj).then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Request Successfully Rejected!",
                                type: "success",
                                timer: 3000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            // this.getPendingList(1);
                            this.getAllSuggestion();
                        } else {
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 3000,
                            });
                        }
                    }).catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            });
        },
    searchVendoraName(requestId, vendorname) {
        console.log(vendorname, 'vendorname', requestId)
        if(vendorname==null){
            this.selected_vendor="";
            this.fetchAllFreightList();
        } else {
            this.fetchAllFreightList(requestId, vendorname);
        }
    },

    searchVendoraNameTable(requestId, vendorname) {
        console.log(vendorname, 'vendornametable', requestId)
        if(vendorname==null){
            this.selected_vendor_table="";
            // this.fetchAllFreightListTable();
        } else {
            // this.fetchAllFreightListTable(requestId, vendorname);
        }
    },

    // fetchAllFreightListTable(requestId, vendorname) {
    //         document.getElementById("overlay").style.display = "block";
    //         var userdata = localStorage.getItem("userData");
    //         var userInfo = JSON.parse(userdata);


    //         const obj = {
    //             // requestid: requestId,
    //             requestid: this.requestId,
    //             // vendorid: `${userInfo.sysusermasterid}`
    //             vendorid: vendorname ? vendorname : null
    //         };
            

    //         // return false
    //         this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/adhocVendorFreightList`,obj).then(result => {
    //             document.getElementById("overlay").style.display = "none";
    //             if (result.body.returnmsg === 'Successful') {
    //                 this.vendorPendingRequest = result.body.returnvalue;
    //                 this.vendor_pending_count = this.vendorPendingRequest.length;
    //                 // this.vendorInfoList = result.body.vendorinfo;
    //             } else {
    //                 this.vendor_pending_count = 0;
    //                 this.vendorPendingRequest = [];
    //                 this.vendorInfoList = []
    //             }
    //         })
    //         .catch((ex) => {
    //             console.log('in catch block');
    //             Swal.fire({
    //                 title:ex,
    //                 icon: "error",
    //             });
    //         });
    // },

    fetchAllFreightList(requestId, vendorname) {
            // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                // requestid: requestId,
                requestid: this.requestId,
                // vendorid: `${userInfo.sysusermasterid}`
                vendorid: vendorname ? vendorname : null
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/adhocVendorFreightList`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorPendingRequest = result.body.returnvalue;
                    this.vendor_pending_count = this.vendorPendingRequest.length;
                    this.vendorInfoList = result.body.vendorinfo;
                    this.currentVendorList = result.body.vendorinfo;
                    console.log(this.currentVendorList, 'this.currentVendorListthis.currentVendorList')

                    let vendorArr = []
                    console.log(this.currentVendorList, 'currentVendorList')
                    console.log(this.vendorNameListAll, 'this.vendorNameListtotal list')
                    for(let i=0;i<this.vendorNameListAll.length;i++) {
                      //if (vendorArr && vendorArr.length > 0) {
                        const newresult = this.currentVendorList.find(item => item.vendorid == this.vendorNameListAll[i].transporter_id)
                        if (newresult) {
                          continue;
                        } else {
                          let vendorObj = {
                        transporter_company_name:this.vendorNameListAll[i].transporter_company_name,
                        vendorid: this.vendorNameListAll[i].transporter_id
                      }
                      vendorArr.push(vendorObj)
                        }
                      //}
                      
                    }      
                    
                    this.vendorNameListTable = vendorArr.map(item => ({
                                    transporter_company_name: item.transporter_company_name + '-(ID :' + item.vendorid+ ' )',
                                    vendorid: item.vendorid
                                }));

                              
                    console.log(this.vendorNameListTable, 'this.vendorNameListTablev'); 
                } else {
                    this.vendor_pending_count = 0;
                    this.vendorPendingRequest = [];
                    this.vendorInfoList = []
                }
            })
            .catch((ex) => {
                console.log('in catch block');
                Swal.fire({
                    title:ex,
                    icon: "error",
                });
            });
    },

    // get vendor list of transpoter is already created
    allVendorList() {
            // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
                type: null
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                  this.vendorNameListAll = result.body.returnvalue;
                    this.vendorNameList = result.body.returnvalue.map(item => ({
                                    transporter_company_name: item.transporter_company_name + '-(ID :' + item.transporter_id+ ' )',
                                    vendorid: item.transporter_id
                                }));


                    // filter record thoes already present in table            
                    
                } else {
                    this.vendorNameList = []
                }
            })
              .catch((ex) => {
                  console.log("error", ex);
                  Swal.fire({
                title:ex,
                icon: "error",
              });
            });
    },

     async addNewFreight () {
        await this.allTransporterVendorList()
        this.vendorInfoList.push({
        basefreight: (this.vendorPendingRequest && this.vendorPendingRequest.length > 0 && this.vendorPendingRequest[0].basefreight !== null) ?  (this.vendorPendingRequest[0].basefreight) : "NA",
        transporter_comapny_name: "",
        freight: "",
        freightp: "",
        showDeleteIcon: 1
      });
     
    },
    
    removeFreightDetails(index, detail) {
        console.log('aa', index, 'akahdk', detail)
        if (detail && detail.addedbyadmin === 'Yes') {
          var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            let obj = {
                bidid: detail.bidid,
                modifiedby: userInfo.userfirstname + " " + userInfo.userlastname
            }

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/deleteFreightForRequest`,obj).then(result => {
                if (result.body.returnmsg === 'Successful') {
                  this.$fire({
                      text: result.body.returnvalue,
                      type: "success",
                      timer: 3000,
                  });
                  this.fetchAllFreightList()
                } else {
                  this.$fire({
                      text: result.body.returnvalue,
                      type: "error",
                      timer: 3000,
                  });
                  this.fetchAllFreightList()
                }
            })
              .catch((ex) => {
                  console.log("error", ex);
                  Swal.fire({
                title:ex,
                icon: "error",
              });
            });
        } else {
          this.vendorInfoList.splice(index, 1);
        }
      
    },

    updateSelectedVendor(index, selectedVendor) {
      // Handle the vendor selection change if needed
      console.log(`Selected vendor for index ${index}: ${selectedVendor}`);
    },

    changeFreightValue(index, freightValue) {
        // Add 10 to the freight value and update freightp
        const freightNumber = freightValue;
        const invoiceValue = (this.vendorPendingRequest && this.vendorPendingRequest[0].invoicevalue) ? this.vendorPendingRequest[0].invoicevalue : ''
        if (!isNaN(freightNumber)) {
            this.vendorInfoList[index].freightp = ((freightNumber / invoiceValue) * 100).toFixed(2); // Update freightp
            console.log(this.vendorInfoList, 'this.vendorInfoList@@@@111');
        } else {
            this.vendorInfoList[index].freightp = ""; // Clear if input is invalid
        }
    },

    // add vendon for table
    allTransporterVendorList() {
        console.log('ok to vendor list')
        // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
                type: 'addvendor'
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa');
                    // return false;
                    this.allTransporterVenList = result.body.returnvalue.map(item => ({
                                    transporter_company_name: item.transporter_company_name,
                                    vendorid: item.transporter_id
                                }));
                } else {
                    this.allTransporterVenList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add new freight
    addFreightInfirmation(index, vendorid) {
      console.log("bidid=================",vendorid)
      let passvendorid = ''
      if (vendorid.vendor_id) {
        passvendorid=vendorid.vendor_id.vendorid
      }
      else{
        passvendorid=vendorid.vendorid
      }
        // console.log('transportername', 'transportername', index, vendorid)
        // console.log(this.vendorInfoList[index], 'value')
        // return false;
        console.log(this.allTransporterVenList, 'this.allTransporterVenList')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            // const vendorInfo = this.allTransporterVenList.find(item => item.transporter_company_name === transportername.transporter_company_name)
            // console.log(vendorInfo, 'vendorInfovendorInfo')
            // let vendirid = null
            // if (vendorInfo) {
            //     vendirid = vendorid
            // } else {
            //     vendirid = null
            // }
            
            const freightInfo = {
                requestid: this.requestId,
                vendorid: passvendorid,
                freight: this.vendorInfoList[index].freight,
                createdby: userInfo.userfirstname + userInfo.userlastname
                // createdby: `${userInfo.sysusermasterid}`
            };
            // console.log(freightInfo, 'freightInfofreightInfo@@')
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addFreightForRequest`,freightInfo).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                  this.fetchAllFreightList();
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnvalue,
                        icon: "success",
                    });
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    

     // add new freight
     editFreightInfirmation(index, details) {
      console.log("details=================",details)
      

        console.log(this.allTransporterVenList, 'this.allTransporterVenList')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            
            const freightInfo = {
                bidid: details.bidid,
                freight: this.vendorInfoList[index].freight,
                modifiedby: userInfo.userfirstname + userInfo.userlastname
            };
            // console.log(freightInfo, 'freightInfofreightInfo@@')
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/editFreightForRequest`,freightInfo).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                  this.fetchAllFreightList();
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnvalue,
                        icon: "success",
                    });
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add vendor
    addVendor() {
        this.updateInfo = !this.updateInfo; 
    },

    // submitVendor 

    submitvenodr() {

      if (!this.addVendorDetails.vendortype) {
        return Swal.fire({
            title:"Vendor Type is required",
            icon: 'error',
        }) 
      }
      

      if (!this.addVendorDetails.transporter_name) {
        return Swal.fire({
            title:"Transporter Name is required",
            icon: 'error',
        }) 
      }

      // if (!this.addVendorDetails.promotername) {
      //   return Swal.fire({
      //       title:" Promoter name is required",
      //       icon: 'error',
      //   }) 
      // } 

      // if (!this.addVendorDetails.gstinnumber && this.addVendorDetails.vendortype && this.addVendorDetails.vendortype.toLowerCase() == 'aggregator') {
      //   return Swal.fire({
      //       title:'GSTIN Number is required',
      //       icon: 'error',
      //   }) 
      // } 
      if (!this.addVendorDetails.pan) {
        return Swal.fire({
            title:'PAN Number is required',
            icon: 'error',
        }) 
      } 
      if (!this.addVendorDetails.aadhar) {
        return Swal.fire({
            title:'Aadhaar Number is required',
            icon: 'error',
        }) 
      }
      // bankcancelledcheque

      if (!this.addVendorDetails.bankcancelledcheque) {
        return Swal.fire({
            title:'Bank cancelled cheque is required',
            icon: 'error',
        }) 
      }

      if (!this.addVendorDetails.address) {
        return Swal.fire({
            title:'Address is required',
            icon: 'error',
        }) 
      }

      if (!this.addVendorDetails.bankname) {
        return Swal.fire({
            title:'Bank name is required',
            icon: 'error',
        }) 
      }

      if (!this.addVendorDetails.bankaccountname) {
        return Swal.fire({
            title:'Bank account is required',
            icon: 'error',
        }) 
      }

      if (!this.addVendorDetails.branchname) {
        return Swal.fire({
            title:'Branch name is required',
            icon: 'error',
        }) 
      }
     

      if (!this.addVendorDetails.accountnumber) {
        return Swal.fire({
            title:'Account number is required',
            icon: 'error',
        }) 
      }
      if (!this.addVendorDetails.ifsccode) {
        return Swal.fire({
            title:'IFSC code is required',
            icon: 'error',
        }) 
      }

     
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const vendorDetail = {
              companyname: this.addVendorDetails.vendorCompanyName,
              emailid: this.addVendorDetails.vendorEmailId,
              mobileno: this.addVendorDetails.vendorMobileNo,
              freight: this.addVendorDetails.addFreight,
              gstno: this.addVendorDetails.gstno,         
              createdby: userInfo.userfirstname + userInfo.userlastname,
              requestid: this.requestId,
              pincode: this.addVendorDetails.pincode ? this.addVendorDetails.pincode.label.toString() : '',
              address: this.addVendorDetails.address ? this.addVendorDetails.address : '',
              city: this.addVendorDetails.city ? this.addVendorDetails.city : '',
              state: this.addVendorDetails.state ? this.addVendorDetails.state : '',
              pan: this.addVendorDetails.pan ? this.addVendorDetails.pan : '',
              bankname: this.addVendorDetails.bankname ? this.addVendorDetails.bankname : '',
              bankaccountname: this.addVendorDetails.bankaccountname ? this.addVendorDetails.bankaccountname : '',
              branchname: this.addVendorDetails.branchname ? this.addVendorDetails.branchname  : '',
              accountnumber: this.addVendorDetails.accountnumber ? this.addVendorDetails.accountnumber : '',
              ifsccode: this.addVendorDetails.ifsccode ? this.addVendorDetails.ifsccode : '',
              aadhar: this.addVendorDetails.aadhar? this.addVendorDetails.aadhar : '',
              vendortype: this.addVendorDetails.vendortype ? this.addVendorDetails.vendortype : '',
              bankcancelledcheque: this.bankcancelledcheque ? this.bankcancelledcheque : '',
              promotername: this.addVendorDetails.promotername ? this.addVendorDetails.promotername : '',
              gstincertificate: this.gstincertificate ? this.gstincertificate : '',
              transporter_name: this.addVendorDetails.transporter_name? this.addVendorDetails.transporter_name: '',
              registered_from:'Admin_Portal_TM'
            };
            // console.log(vendorDetail, 'vendorDetail')
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addVendorForAdhocVehicleRequest`,vendorDetail).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    });
                    this.updateInfo = !this.updateInfo; 
                    this.addVendorDetails = {}
                    this.errors = {}
                    this.fetchAllFreightList();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },


    // upload csv

    uploadcsvFile(event) {
    // Check if file is selected
    if (!this.file) {
      this.$fire({
        text: "Please select a CSV file before uploading.",
        type: "error",
        timer: 30000,
      });
      return;
    }

    console.log('111');
    this.selectcsvFile = this.file;  // Access file via v-model

    // Validate file type
    this.selectFiletype = this.selectcsvFile.type;
    console.log("selectFiletype", this.selectFiletype);

    // Show overlay during upload
    document.getElementById("overlay").style.display = "block";

    // Fetch user data from localStorage
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);

    // Validate CSV file type
    if (this.selectFiletype === "text/csv") {
      let data = new FormData();
      data.append("file", this.selectcsvFile);
      data.append("requestid", this.requestId);
      data.append("createdby", userInfo.userfirstname + userInfo.userlastname);

      // Axios POST request
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/addVendorsForAdhocVehicleRequestViaCsv`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((result) => {
          document.getElementById("overlay").style.display = "none";
          this.resultMsg = result.body.returnmsg;

          // Show success or error messages
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.fetchAllFreightList();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }

          // Reset the file input and other variables
          this.resetFileInput();
        })
        .catch((ex) => {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Error during upload. Please try again.",
            type: "error",
            timer: 30000,
          });
          console.log("error", ex);

          // Reset the file input and other variables
          this.resetFileInput();
        });
    } else {
      // Invalid file type error
      document.getElementById("overlay").style.display = "none";
      this.$fire({
        text: "Please Upload CSV File Only",
        type: "error",
        timer: 30000,
      });
      this.resetFileInput();
    }
  },

  // Function to reset file input and other variables
  resetFileInput() {
    this.selectcsvFile = "";
    this.selectFiletype = "";
    this.file = "";
    // Clear the file input using DOM manipulation
    document.getElementById('csvFile').value = null;
  },

    // suggestion
    toggleStar(index, details) {
      this.currentBidID = details.bidid;
      this.suggested_reason= '';
      this.comment= '';
      if (this.selectedStarIndex === index) {
        // If the clicked star is already selected, deselect it
        this.enableSuggestionAndComment = true;
        this.selectedStarIndex = null;
      } else {
        // Otherwise, select the new star
        this.enableSuggestionAndComment = false;
        this.selectedStarIndex = index;
      }
    },
    isStarred(index, details) {
      this.enableSuggestionAndComment = true;
      return this.selectedStarIndex === index;
    },
    // toggleStar(index) {
    //   const rowIndex = this.starredRows.indexOf(index);
    //   if (rowIndex === -1) {
    //     this.enableSuggestionAndComment = true;

    //     // Add index to starredRows if not already present
    //     this.starredRows.push(index);
    //   } else {
    //     this.enableSuggestionAndComment = false;

    //     // Remove index from starredRows if already present
    //     this.starredRows.splice(rowIndex, 1);
    //   }
    // },
    // isStarred(index) {
    //   this.disableSuggestionReasonFreight = true;
    //   return this.starredRows.includes(index); // Check if the row is starred
    // },

    // submit suggestion
    submitSuggestion () {
      console.log('this.currentBidID', this.currentBidID)
      document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const markSuggestion = {
                  requestid: this.requestId,
                  bidid: this.currentBidID,
                  reason: this.suggested_reason,
                  comment: this.comment ? this.comment : null,
                  createdby: userInfo.userfirstname + userInfo.userlastname,
                  sysusermasterid: userInfo.sysusermasterid
            };
            // console.log(markSuggestion, 'markSuggestionmarkSuggestion');
            // return false;

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/markVendorAsSuggestion`,markSuggestion).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    }); 
                    this.getAllSuggestion();
                    this.fetchAllFreightList();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },
    

    // get all suggestion here
    getAllSuggestion() {
      console.log('ok to vendor list')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRequestLogs`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa vendor');
                    // return false;

                    this.getAllSuggestionList = result.body.returnvalue
                } else {
                    this.getAllSuggestionList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    closeVendorModal() {
      this.updateInfo = !this.updateInfo; 
      this.addVendorDetails = {}
      this.errors = {}
    },

    resetForm() {
      // Clear the form fields
      this.addVendorDetails = {}
      this.errors = {}
    },

    UploadFreightPopUp() {
      this.uploadCSVModal = !this.uploadCSVModal; 
    },

    downloadVendorCSV() {
      console.log('ok to vendor list')
        // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.loadurl =  `${CONSTANTS.MIGRATION_API_URL}/downloadVendorDetailsCsv`;

console.log("loadurl",loadurl)
      //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // // Create a download link and trigger the download
      // const link = document.createElement("a");
      // if (link.download !== undefined) {
      //   const url = URL.createObjectURL(blob);
      //   link.setAttribute("href", url);
      //   link.setAttribute("download", "vendor_data.csv");
      //   link.style.visibility = 'hidden';
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // }
      //       // return false
      // console.log(this.loadurl)



            // this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/downloadVendorDetailsCsv`).then(result => {
            //   this.loadurl = result.url;
            // })
            // .catch((ex) => {
            //     console.log("error", ex);
            //     Swal.fire({
            //   title:ex,
            //   icon: "error",
            // });
            // });
    },

    editField(index) {
      if (this.currentEditIndex === index) {
      this.currentEditIndex = null;  // Disable edit mode for the row
    } else {
      this.currentEditIndex = index;  // Enable edit mode for the row
    }
    },

    isEditable(index) {
      return this.currentEditIndex === index;
    },

    downloadSampleCSV () {

    },

    // validation start here

    // Validation methods
    validateCompanyName() {
        console.log('ok12871');
      if (!this.addVendorDetails.vendorCompanyName) {
        this.errors.vendorCompanyName = 'Company name is required';
      } else {
        this.errors.vendorCompanyName = null;
      }
    },

    validateMobileNo() {
      const mobilePattern = /^[0-9]{10,12}$/;
      if (!mobilePattern.test(this.addVendorDetails.vendorMobileNo)) {
        this.errors.vendorMobileNo = 'Please enter a valid mobile number';
      } else {
        this.errors.vendorMobileNo = null;
      }
    },

    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.addVendorDetails.vendorEmailId)) {
        this.errors.vendorEmailId = 'Please enter a valid email address';
      } else {
        this.errors.vendorEmailId = null;
      }
    },
    
    validateFreight() {
      if (!this.addVendorDetails.addFreight || isNaN(this.addVendorDetails.addFreight)) {
        this.errors.addFreight = 'Freight should be a valid number';
      } else {
        this.errors.addFreight = null;
      }
    },
    
    planViewclickCallback(planviewpageNum){
            this.viewPlanDetails(planviewpageNum,this.planDetails)
        },

        viewPlanDetails(pageno,value,openmodel) {
            this.loadermodel=true;
            this.planDetails = {};
           
            this.planDetails = value;
            this.plandetailsmodal = true;
            if (openmodel=='openmodel') {
                pageno=1;
                this.planviewpageNum=1;
            }
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
            
                const obj = {
                    planid: `${this.planDetails.planid}`,
                    // planid:'101',
                    pageno: `${pageno}`,
                };

                // return false
                this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getPlanDetailsForRequest`,obj).then(result => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.planScrrenDetails = result.body.returnvalue;
                        this.planScrrenDetails_count =  result.body.totalcount;
                        this.planviewnoofpages=parseInt(this.planScrrenDetails_count)/10;
                        this.planviewnoofpages=Math.ceil( this.planviewnoofpages);
                    } else {
                        this.planviewnoofpages='';
                        this.planScrrenDetails = [];
                        this.planScrrenDetails_count = 0;
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            
        },

    addGSTNumber() {
      // Regular expression for validating GST number format (India)
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      // Clear previous error
      this.errors.gstno = null;

      // Validation rules
      if (!this.addVendorDetails.gstno) {
        // Check if GST number is empty
        this.errors.gstno = "GST number is required.";
      } else if (!gstRegex.test(this.addVendorDetails.gstno)) {
        // Check if GST number matches the regex pattern
        this.errors.gstno = "Invalid GST number format.";
      }
    },

    getPincodeList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={}
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    this.pincodeCityData = result.body.returnvalue;                    
                    for(let i=0;i<this.pincodeCityData.length;++i){
                        this.pincodes.push({
                            key:this.pincodeCityData[i].vendorpincode,
                            label:this.pincodeCityData[i].vendorpincode
                        })
                    }
                    console.log("pincodes-->",this.pincodes) 
                }
                else{
                    this.pincodes=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
    },

    selectBankChequeFile(event){
          this.selectedBankCheque= event.target.files[0];            
          if (this.selectedBankCheque) {
              this.errors.bankcancelledcheque = null;
              this.bankFileName = `${event.target.files[0].name}`; 
              this.bankFileType = this.selectedBankCheque.type;
              this.uploadBankCheque(this.selectedBankCheque);
          }    
    },

    uploadBankCheque : function () {
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);

        let data = new FormData();
        data.append('file', this.selectedBankCheque)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
            {
                header : { 'Content-Type' : 'multipart/form-data'
                }, 
            })
        .then(response => {
            if (response.data.result=='success') {
                this.$fire({
                    text:"File Uploaded",
                    type: "success",
                    timer: 300000
                })
                this.bankcancelledcheque=response.data.image_url;                    
            } else {
                this.$fire({
                    text:"File Not Uploaded",
                    type: "error",
                    timer: 300000
                })
            }
        })
        .catch(e => {
            console.log('Error In Upload Bank check',e);
            
        })
    
    },
    selectGstinCertficateFile(event){
        this.selectedGstinCertficate= event.target.files[0];            
        if (this.selectedGstinCertficate) {
            this.gstinCertficateFilename = `${event.target.files[0].name}`; 
        }
        this.gstinCertficateType = this.selectedGstinCertficate.type;
        this.uploadGstin(this.selectedGstinCertficate);

    },

    uploadGstin : function () {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);

        let data = new FormData();
        data.append('file', this.selectedGstinCertficate)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
            {
                header : { 'Content-Type' : 'multipart/form-data'
                }, 
            })
        .then(response => {
            if (response.data.result=='success') {
                this.$fire({
                    text:"File Uploaded",
                    type: "success",
                    timer: 300000
                })
                this.gstincertificate=response.data.image_url;                    
            } else {
                this.$fire({
                    text:"File Not Uploaded",
                    type: "error",
                    timer: 300000
                })
            }
        })
        .catch(e => {
            console.log('Error in upload GSTIN certificate',e);
            
        })
    
    },

     pincodeChange(pincode) {       
        this.$set(this.addVendorDetails, 'city', '');
        this.$set(this.addVendorDetails, 'state', '');
        if (pincode) {
          const selectedPincode = this.pincodeCityData.find(
              item => item.vendorpincode == pincode.label
          );

            if (selectedPincode) {
                this.$set(this.addVendorDetails, 'city', selectedPincode.vendorcity);
                this.$set(this.addVendorDetails, 'state', selectedPincode.vendorstate);
            }
        }
        
    },
    checkNegativeValue: function (event) {
      // Check if the key pressed is the '-' key
      if (event.key === '-') {
        event.preventDefault(); // Prevent entering a negative sign
      }
    },
    
  }
}

</script>

<style scoped>
.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
background-color: #E8E4E4 !important;
padding: 4px !important;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
outline: none !important;
background-color: #E8E4E4 !important;
box-shadow: none !important;
padding: 4px !important;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}

.modal-center-title .modal-header {
    justify-content: center;
    width: 100%;
}

.modal-center-title .modal-title {
    text-align: center;
    width: 100%;
}
.custom-Freight-lowest-price {
    background-color: #C0EA47 !important;
    color: #000 !important;
    padding: 8px !important;
    border: none !important;
}
.custom-Freight-lowest-price:focus {
    background-color: #C0EA47 !important;
    color: #000 !important;
    padding: 8px !important;
    border: none !important;
    outline: none !important;
}
.custom-field-vendor {
  background-color: #C0EA47 !important;
    color: #000 !important;
}
.custom-table-icon {
  background: none !important;
  border: none !important;
  outline: none;
}
.custom-table-icon:focus {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-icon:active{
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-close-btn .clear {
    /* Add your styles here */
    background: none !important;
    background-color: none !important;
    color: #b0c4de !important;
}

.custom-table-outer {
  padding: 20px !important;
  border: 1px solid #000 !important;
}

.custom-background-clear .v-select .dropdown-toggle .clear  {
  background: none !important;
}
.custom-border label{
    overflow: hidden !important;
    line-height: 22px !important;
}
</style>